
export function queryRecord(vueInstance, value, queryType, TypeFilter='') {

    const qry = {        
        "QueryContent": value,
        "QueryType": queryType,
        "SourcePage": vueInstance.$route.name,
        "TypeFilter": TypeFilter
    }
    
    if( TypeFilter.trim() == "" ) {
        delete qry.TypeFilter;
    }

    vueInstance.$api.apianalysis.userQueryRecord(qry).then(() => {
        //console.log('記錄查詢成功:', response);
    }).catch((error) => {
        console.error('記錄查詢失敗:', error);
    });
}

export default {
    queryRecord,
};